import { cn } from '#/lib/utils'

/** Decorative brand companion; adjacent copy provides the meaning of each state. */
export function Mascot({ className, size = 96, eager = false }: { className?: string; size?: number; eager?: boolean }) {
  return (
    <img
      src="/brand/mascot-256.png"
      srcSet="/brand/mascot-256.png 256w, /brand/mascot-512.png 512w"
      sizes={`${size}px`}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      draggable={false}
      className={cn('bystep-mascot block shrink-0 object-contain', className)}
    />
  )
}
